import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";

import {
  GuardableAccount,
  shouldInhibitRiskActions,
} from "../utils/account-guardrails.util";

/**
 * Diretiva estrutural que oculta o elemento quando a conta é sistêmica (ou quando
 * a informação está indisponível — fail-safe).
 *
 * Na listagem (menu ⋮): envolve ações de risco (bloquear, excluir, redefinir,
 * desbloquear, alterar perfil). Editar usa `canEditAccount`; Visualizar produtos
 * não usa esta diretiva.
 * No sidenav: ações de risco (bloquear, excluir, redefinir senha).
 *
 * @example
 * ```html
 * <button *appHideIfSystemic="user" (click)="edit(user)">Editar usuário</button>
 * ```
 */
@Directive({
  selector: "[appHideIfSystemic]",
  standalone: false,
})
export class HideIfSystemicDirective implements OnInit {
  @Input() appHideIfSystemic?: GuardableAccount | null;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    if (shouldInhibitRiskActions(this.appHideIfSystemic)) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
